import React, { useState } from 'react';
import { AlertTriangle, Mail, X } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const EmailVerificationBanner = ({ user }) => {
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const handleResend = async () => {
    setResending(true);
    try {
      await axios.post(`${BACKEND_URL}/api/auth/resend-verification`, {}, {
        headers: { Authorization: `Bearer ${user?.token}` }
      });
      setResent(true);
    } catch (err) {
      alert(err.response?.data?.detail || 'Failed to resend. Please try again.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-3">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0" />
          <div className="text-sm text-amber-800">
            <span className="font-semibold">Please verify your email to unlock all features.</span>
            {' '}Check your inbox (and spam/junk folder) for the verification link.
          </div>
        </div>
        <div className="flex items-center space-x-3">
          {resent ? (
            <span className="text-sm text-green-600 font-semibold">✓ Sent!</span>
          ) : (
            <button
              onClick={handleResend}
              disabled={resending}
              className="flex items-center space-x-1 text-sm text-amber-700 hover:text-amber-900 font-semibold transition-colors"
            >
              <Mail className="w-4 h-4" />
              <span>{resending ? 'Sending...' : 'Resend'}</span>
            </button>
          )}
          <button onClick={() => setDismissed(true)} className="text-amber-400 hover:text-amber-600">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
